// src/services/settingService.js
import API_BASE_URL from "../config/apiConfig";
import createApiClient from "../config/apiClient";

const apiClient = createApiClient(API_BASE_URL);
const API_URL = "/settings";

// ========== ADMIN ROUTES ==========

// Lấy tất cả settings cho admin
export const getSettingForAdmin = async () => {
  try {
    const response = await apiClient.get(`${API_URL}/admin`);
    return response.data;
  } catch (error) {
    console.error('Error fetching settings for admin:', error);
    throw error;
  }
};

// Cập nhật cài đặt chung
export const updateCommonSetting = async (data) => {
  try {
    const response = await apiClient.put(`${API_URL}/admin/common`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating common setting:', error);
    throw error;
  }
};

// Cập nhật cài đặt mạng xã hội
export const updateSocialSetting = async (data) => {
  try {
    const response = await apiClient.put(`${API_URL}/admin/social`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating social setting:', error);
    throw error;
  }
};

// Cập nhật cài đặt SMTP
export const updateSTMPSetting = async (data) => {
  try {
    const response = await apiClient.put(`${API_URL}/admin/smtp`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating SMTP setting:', error);
    throw error;
  }
};

// Gửi email thử nghiệm (Test Email)
export const testEmail = async () => {
  try {
    const response = await apiClient.post(`${API_URL}/admin/smtp/test`);
    return response.data;
  } catch (error) {
    console.error('Error testing email:', error);
    throw error;
  }
};

// Cập nhật cài đặt SEO & Meta
export const updateSeoAndMetaSetting = async (data) => {
  try {
    const response = await apiClient.put(`${API_URL}/admin/seo-meta`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating SEO & Meta setting:', error);
    throw error;
  }
};

// Cập nhật cài đặt footer
export const updateFooterSetting = async (data) => {
  try {
    const response = await apiClient.put(`${API_URL}/admin/footer`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating footer setting:', error);
    throw error;
  }
};

// ========== CUSTOMER ROUTES ==========

// Lấy footer cho khách hàng
export const getFooterForCustomer = async () => {
  try {
    const response = await apiClient.get(`${API_URL}/customer/footer`);
    return response.data;
  } catch (error) {
    console.error('Error fetching footer for customer:', error);
    throw error;
  }
};

// Lấy thông tin liên hệ cho khách hàng
export const getContactForCustomer = async () => {
  try {
    const response = await apiClient.get(`${API_URL}/customer/contact`);
    return response.data;
  } catch (error) {
    console.error('Error fetching contact for customer:', error);
    throw error;
  }
};

// Lấy thông tin SEO cho khách hàng
export const getSeoForCustomer = async () => {
  try {
    const response = await apiClient.get(`${API_URL}/customer/seo`);
    // Đảm bảo response.data tồn tại và hợp lệ
    if (!response || !response.data) {
      return { success: false, data: null };
    }
    return response.data;
  } catch (error) {
    // Xử lý trường hợp response.data là undefined
    if (error.response && !error.response.data) {
      return { success: false, data: null };
    }
    console.error('Error fetching SEO for customer:', error);
    throw error;
  }
};